import axios from "axios"

export const createChat = ({ contactsIds, name }) => axios.post("/api/v1/conversations", { recipient_ids: contactsIds, name })

export const updateChatName = ({ conversationId, name }) => axios.patch(`/api/v1/conversations/${conversationId}`, { name })

export const chats = ({ cursor, archived, membersIds }) =>
  axios.get("/api/v1/conversations", {
    params: {
      older_than: cursor,
      archived,
      contains_member_ids: membersIds
    }
  })

export const archiveChat = (conversationId) => axios.post(`/api/v1/conversations/${conversationId}/archive`)

export const unarchiveChat = (conversationId) => axios.post(`/api/v1/conversations/${conversationId}/unarchive`)

export const chat = (id) => axios.get(`/api/v1/conversations/${id}`)

export const messages = ({ conversationId, cursor }) =>
  axios.get(`/api/v1/conversations/${conversationId}/messages`, {
    params: {
      older_than: cursor
    }
  })

export const sendMessage = ({ content, conversationId, replyToId }) =>
  axios.post(`/api/v1/conversations/${conversationId}/messages`, { content, reply_to_id: replyToId })

export const deleteMessage = (messageId) => axios.delete(`/api/v1/messages/${messageId}`)

export const editMessage = ({ messageId, content }) => axios.put(`/api/v1/messages/${messageId}`, { content })

export const leaveConversation = (conversationId) => axios.delete(`/api/v1/conversations/${conversationId}/membership`)

export const markMessageAsRead = ({ id }) => axios.post(`/api/v1/messages/${id}/mark_as_read`)

export const markConversationAsUnread = ({ id }) => axios.post(`/api/v1/conversations/${id}/mark_as_unread`)

export const markAllConversationsAsRead = () => axios.post("/api/v1/conversations/mark_all_as_read")

export const unfollowUser = ({ userId }) => axios.delete(`/api/v1/followed_users/${userId}`)

export const blockUser = ({ userId }) => axios.post(`/api/v1/accounts/${userId}/ignore`)

export const unblockUser = ({ userId }) => axios.delete(`/api/v1/accounts/${userId}/ignore`)

export const usersAvailableForChat = ({ query, page }) =>
  axios.get("/api/v1/conversations/available_users", {
    params: {
      query,
      page,
      per_page: 50
    }
  })
